import React from "react";
import styled from 'styled-components';
import Modal from "./modal/Modal";
import AssignPatient from "./AssignPatient";
import { baseUrl } from "./url";
import moment from "moment";
import loader from "../assets/loader.svg";
import ConfirmPassword from "./ConfirmPassword";

const ProfileWrapper = styled.div`
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  border-radius: 3px;
  padding: 40px 32px;
`;

const ProfileHeader = styled.div`
  display: flex;
`;

const ProfileDetail = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 35px;
`;

const NameBadge = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: #6C63FF;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
`;

const EditButton = styled.button`
  margin: 0;
  padding: 0;
  background: #7C74FE;
  border: 1px solid #6C63FF;
  box-sizing: border-box;
  box-shadow: 0px 1px 0px rgba(22, 29, 37, 0.1), inset 0px 1px 0px rgba(255, 255, 255, 0.06);
  border-radius: 3px;
  color: #FFFFFF;
  text-align: center;
  width: 105px;
  height: 30px;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  margin-right: 25px;
`;
const ArchiveButton = styled.button`
  background: #FFFFFF;
  box-shadow: 0px 1px 3px rgba(63, 63, 68, 0.15), 0px 0px 0px rgba(63, 63, 68, 0.05);
  border-radius: 3px;
  border: 1px solid #BC3E06;
  box-sizing: border-box;
  color: #BC3E06;
  text-align: center;
  width: 105px;
  height: 30px;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  margin-right: 25px;
`;

const ContactDetailsCard = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 31px;
`;

const OtherDetailsWrapper = styled.div`
  margin-top: 45px;
`;
const ContactHeader = styled.h6`
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #212B36;
  mix-blend-mode: normal;
  opacity: 0.8;
  margin-bottom: 5px;
`;

const ContactBody = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 14px;
  color: #919EAB;
`;


class CaregiverProfile extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
      showPasswordModal: false,
      bio: {},
      name: "",
      response: false,
      patients: [],
      point: -1,
      userType: 'caregiver'
    };
    this.showModal = this.showModal.bind(this);
    this.showPasswordModal = this.showPasswordModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.hidePasswordModal = this.hidePasswordModal.bind(this);
    this.showUser = this.showUser.bind(this);
    this.fetchPatients = this.fetchPatients.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    let token = localStorage.getItem("access_token"),
      user_id = localStorage.getItem("user_id"),
      user_t = localStorage.getItem("user_type"),
      retries = 0;

    if ("care_giver" === user_t) {
      localStorage.setItem("caregiver_id", user_id);
    }
    if (user_t === "patient") {
      user_t = "care_giver";
      user_id = localStorage.getItem("caregiver_id");
      localStorage.setItem("user_id", user_id);
      localStorage.setItem("user_type", user_t);
    }

    fetch(`${baseUrl}/admin/users/${user_t}/${user_id}`, {
      method: "GET",
      headers: {
        Authorization: token
      }
    })
      .then(response => {
        const auth = response.headers.get("Authorization");
        localStorage.setItem("access_token", auth);
        return response.json();
      })
      .then(responseJson => {
        console.dir(responseJson);
        this.setState({
          bio: responseJson.data.bio,
          name: responseJson.data.bio.name,
          point: responseJson.data.bio.progress.point,
          response: true
        });
      })
      .catch(error => {
        if (error === 401 && retries < 1) {
          localStorage.getItem("access_token").then(value => {
            fetch(`${baseUrl}/token/refresh`, {
              headers: {
                Accept: "application/json",
                Authorization: value
              }
            }).then(response => {
              retries += 1;
              if (response.status === 200) {
                localStorage.setItem(
                  "access_token",
                  response.headers.get("Authorization")
                );
                this.handleSubmit();
              } else {
                alert("something went wrong please try again later");
              }
            });
          });
        } else {
          alert("something went wrong please try again later");
        }
      });
    this.fetchPatients();
  }

  fetchPatients() {
    let token = localStorage.getItem("access_token"),
      user_id = localStorage.getItem("user_id"),
      retries = 0;

    fetch(`${baseUrl}/admin/caregivers/${user_id}/patients`, {
      method: "GET",
      headers: {
        Authorization: token
      }
    })
      .then(response => {
        const auth = response.headers.get("Authorization");
        localStorage.setItem("access_token", auth);
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          patients: responseJson.data
        });
      })
      .catch(error => {
        if (error === 401 && retries < 1) {
          localStorage.getItem("access_token").then(value => {
            fetch(`${baseUrl}/token/refresh`, {
              headers: {
                Accept: "application/json",
                Authorization: value
              }
            }).then(response => {
              retries += 1;
              if (response.status === 200) {
                localStorage.setItem(
                  "access_token",
                  response.headers.get("Authorization")
                );
                this.handleSubmit();
              } else {
                alert("something went wrong please try again later");
              }
            });
          });
        } else {
          alert("something went wrong please try again later");
        }
      });
  }
  showModal(id, name) {
    this.setState({
      show: true,
      patientName: name,
      patientId: id
    });
  }
  showPasswordModal(id) {
    this.setState({
      showPasswordModal: true,
      patientId: id
    })
  }
  hideModal() {
    this.setState({ show: false });
    this.fetchPatients();
  }

  hidePasswordModal() {
    this.setState({showPasswordModal: false});
  }


  showUser(id, type) {
    if (type === "caregiver") {
      localStorage.setItem("user_type", "care_giver");
    } else {
      localStorage.setItem("user_type", type);
    }
    localStorage.setItem("user_id", JSON.stringify(id));
    this.props.history.push(`/${type}`);
  }

  render() {
    let { name, bio, response } = this.state;
    let icon, nameBadge;
    if (response) {
      icon = name;
      let matches = icon.match(/\b(\w)/g);
      nameBadge = matches.join("").toUpperCase();
    }
    return (
      <div className="caregiver-profile">
        {!response && (
          <div className="loader-div">
            <img src={loader} alt="" />
          </div>
        )}
        {response && (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-4">
                <ProfileWrapper>
                  <ProfileHeader>
                    <NameBadge>
                      <h4>{nameBadge}</h4>
                    </NameBadge>

                    <ProfileDetail>
                      <h6>{bio.name}</h6>
                      <p>{this.state.patients.length} Patients assigned</p>
                    </ProfileDetail>
                  </ProfileHeader>

                    <ButtonWrapper>
                      <EditButton>Edit User</EditButton>
                      <ArchiveButton onClick={() => this.showPasswordModal(localStorage.getItem("user_id"))}>Archive user</ArchiveButton>
                    </ButtonWrapper>

                    <OtherDetailsWrapper>
                      <ContactDetailsCard>
                        <ContactHeader>Contact</ContactHeader>
                        <ContactBody>{bio.phone_no}</ContactBody>
                      </ContactDetailsCard>


                      <ContactDetailsCard>
                        <ContactHeader>Alias</ContactHeader>
                        <ContactBody>{bio.alias}</ContactBody>
                      </ContactDetailsCard>
                    </OtherDetailsWrapper>


                    <ContactDetailsCard>
                        <ContactHeader>Email</ContactHeader>
                        <ContactBody>{bio.email}</ContactBody>
                      </ContactDetailsCard>

                </ProfileWrapper>

              </div>
              <div className="col-sm-4">
                <div className="caregiver-patients">
                  <div className="top">Assigned Patients</div>
                  {this.state.patients.length === 0 && (
                    <div className="top">
                      <small>No patient assigned to this caregiver yet.</small>
                    </div>
                  )}
                  <table>
                    <tbody>
                      {this.state.patients.map(patient => {
                        let date = moment().format("YYYY-MM-DD");
                        let t_time = moment(
                          `${date} ${patient.treatment.time}`
                        ).format("hh:mmA");
                        let name = patient.name;
                        let matches = name.match(/\b(\w)/g);
                        let nameBadge = matches.join("").toUpperCase();
                        return (
                          <tr key={patient.id}>
                            <td
                              onClick={() =>
                                this.showUser(patient.id, "patient")
                              }
                            >
                              <div className="name-badge">{nameBadge}</div>
                            </td>
                            <td>
                              <h6>{name}</h6>
                              <p>Treatment time {t_time}</p>
                            </td>
                            <td>
                              <button
                                onClick={() => this.showModal(patient.id, name)}
                              >
                                Change
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="button-div">
                    {/* <button onClick={this.showModal}><i className="fa fa-plus-circle"></i>Assign new patient</button> */}
                  </div>
                  <Modal show={this.state.show} handleClose={this.hideModal}>
                    {this.state.show && (
                      <AssignPatient
                        name={this.state.patientName}
                        id={this.state.patientId}
                      />
                    )}
                  </Modal>

                  <Modal show={this.state.showPasswordModal} handleClose={this.hidePasswordModal}>
                    {this.state.showPasswordModal && (
                      <ConfirmPassword
                        action='archive'
                        userType={this.state.userType}
                        userID={this.state.patientId}
                      />
                    )}
                  </Modal>
                </div>
              </div>
              <div className="col-sm-4">
                {/* <div className="appointments">
                                    <h6>Appointments</h6>
                                    <p>No appointments yet</p>
                                    <button><i className="fa fa-plus-circle"></i>Add appointment</button>
                                </div> */}
                <div className="key-metrics">
                  <h6>This Month</h6>
                  <p>
                    <span>0</span>Appointments
                  </p>
                  <p>
                    <span>0</span>VOT Submissions
                  </p>
                </div>

                <div className="key-metrics">
                  <h6>Reward Points</h6>
                  <p>
                    <span>{this.state.point}</span>Earned points
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CaregiverProfile;



// WEBPACK FOOTER //
// ./src/components/CaregiverProfile.js